"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onMessageReceivedFromIframe = void 0;
const lodash_1 = require("lodash");
const onMessageReceivedFromIframe = (event, subscribers) => {
    var _a, _b;
    const transformedSubscribers = (0, lodash_1.groupBy)(Object.values(subscribers.current), (item) => item.eventType);
    const data = (_a = event.message) !== null && _a !== void 0 ? _a : event.data;
    if (data === null || data === void 0 ? void 0 : data.event_id) {
        (_b = transformedSubscribers[data.event_id]) === null || _b === void 0 ? void 0 : _b.forEach((subscriber) => {
            subscriber.callback(data.event_payload);
        });
    }
};
exports.onMessageReceivedFromIframe = onMessageReceivedFromIframe;
//# sourceMappingURL=utils.js.map